export default __webpack_public_path__ + "static/mobile_img-c8c873dabbc124e56b99b306b8eab625.jpg";